import "core-js/modules/es6.number.constructor";
import "core-js/modules/web.dom.iterable";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import getUserAgent from '@/util/getUserAgent';
import getUrlParam from '@/util/getUrlParam';
function getServerSetting() {
  return _getServerSetting.apply(this, arguments);
}
function _getServerSetting() {
  _getServerSetting = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
    var res;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return DataRequest('setting');
          case 3:
            res = _context4.sent;
            return _context4.abrupt("return", res);
          case 7:
            _context4.prev = 7;
            _context4.t0 = _context4["catch"](0);
            console.log('异常了', _context4.t0);
            return _context4.abrupt("return", {
              error: true
            });
          case 11:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 7]]);
  }));
  return _getServerSetting.apply(this, arguments);
}
function getWelfareData(_x, _x2, _x3) {
  return _getWelfareData.apply(this, arguments);
}
function _getWelfareData() {
  _getWelfareData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(beginIndex, pageNum, ctxInfo) {
    var ua, platform, isPreRelease, param, res, _window$aegis, _window$aegis2;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            ua = getUserAgent(ctxInfo);
            platform = ua.indexOf('iPhone') >= 0 ? 7 : 8; // iPlatForm;//平台 iphone 7 android 8
            isPreRelease = getUrlParam('is_prepublish', ctxInfo) ? 1 : 0;
            param = {
              beginIndex: beginIndex,
              pageNum: pageNum,
              platform: platform,
              isPreRelease: isPreRelease
            };
            _context5.prev = 4;
            _context5.next = 7;
            return DataRequest('welfare', param, ctxInfo);
          case 7:
            res = _context5.sent;
            res.data.vModList.forEach(function (item) {
              item.data = item.iModType === 0 ? item.tCommData : item.tMultiData;
            });
            if (Number(res.ret) !== 0) {
              try {
                console.log('web请求福利列表结果出错', res);
                (_window$aegis = window.aegis) === null || _window$aegis === void 0 ? void 0 : _window$aegis.vWarn({
                  tag: 'web请求福利列表结果出错',
                  error: res
                });
              } catch (_) {}
            }
            return _context5.abrupt("return", res.data);
          case 13:
            _context5.prev = 13;
            _context5.t0 = _context5["catch"](4);
            try {
              (_window$aegis2 = window.aegis) === null || _window$aegis2 === void 0 ? void 0 : _window$aegis2.vWarn({
                tag: 'web请求福利列表数据异常',
                error: _context5.t0
              });
            } catch (_) {}
          case 16:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[4, 13]]);
  }));
  return _getWelfareData.apply(this, arguments);
}
export default {
  namespaced: true,
  // 服务端运行时需要改成函数形式，避免成为单例
  state: function state() {
    return {
      welfare: null,
      serverSetting: null,
      nextBeginIndex: 0,
      // 下一次拉取的开始索引
      perNum: 10 // 每次拉取的模块数量
      // isEnd: false // 是否全部拉取完毕
    };
  },

  mutations: {
    saveServerSetting: function saveServerSetting(state, _ref) {
      var serverSetting = _ref.serverSetting;
      state.serverSetting = serverSetting;
    },
    saveWelfare: function saveWelfare(state, _ref2) {
      var welfare = _ref2.welfare,
        _ref2$isRefresh = _ref2.isRefresh,
        isRefresh = _ref2$isRefresh === void 0 ? false : _ref2$isRefresh;
      state.nextBeginIndex = welfare.iNextBeginIndex;
      // 返回结果是空，就不循环请求了
      if (!welfare.vModList.length) {
        state.nextBeginIndex = -1;
      }
      if (isRefresh || !state.welfare) {
        state.welfare = welfare;
      } else {
        state.welfare.vModList = state.welfare.vModList.concat(welfare.vModList);
      }
    }
  },
  getters: {
    isEnd: function isEnd(state) {
      return state.nextBeginIndex === -1;
    }
  },
  actions: {
    /**
     * 自动分页请求福利社数据接口
     * @returns {Promise.<void>}
     */getWelfare: function () {
      var _getWelfare = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref3) {
        var commit, state, getters, rootState, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit = _ref3.commit, state = _ref3.state, getters = _ref3.getters, rootState = _ref3.rootState;
                if (!getters.isEnd) {
                  _context.next = 3;
                  break;
                }
                return _context.abrupt("return");
              case 3:
                _context.next = 5;
                return getWelfareData(state.nextBeginIndex, state.perNum, rootState.ctxInfo);
              case 5:
                data = _context.sent;
                commit('saveWelfare', {
                  welfare: data
                });
              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      function getWelfare(_x4) {
        return _getWelfare.apply(this, arguments);
      }
      return getWelfare;
    }(),
    setServerSetting: function () {
      var _setServerSetting = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref4) {
        var commit, state, getters, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                commit = _ref4.commit, state = _ref4.state, getters = _ref4.getters;
                _context2.next = 3;
                return getServerSetting();
              case 3:
                data = _context2.sent;
                commit('saveServerSetting', {
                  serverSetting: data
                });
              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      function setServerSetting(_x5) {
        return _setServerSetting.apply(this, arguments);
      }
      return setServerSetting;
    }(),
    refreshWelfare: function () {
      var _refreshWelfare = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref5) {
        var commit, state, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                commit = _ref5.commit, state = _ref5.state;
                _context3.next = 3;
                return getWelfareData(0, state.perNum);
              case 3:
                data = _context3.sent;
                commit('saveWelfare', {
                  welfare: data,
                  isRefresh: true
                });
              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      function refreshWelfare(_x6) {
        return _refreshWelfare.apply(this, arguments);
      }
      return refreshWelfare;
    }()
  }
};